<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl">
        <apexchart
            :type="widget.content.chartData.chart.type"
            height="150"
            :series="widget.content.chartData.series"
            :options="widget.content.chartData"
        >
        </apexchart>
        <div v-if="widget.content.lines" class="text-xs">
            <ul>
                <li v-for="line in widget.content.lines">{{ line }}</li>
            </ul>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';

export default {
    name: 'GraphWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        BaseWidget,
    },
};
</script>
